export default "__VITE_ASSET__sZzBnzGE__"